import { h } from '@stencil/core';

const AcceptedCircle = () => {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="18" r="18" fill="#55CC99"/>
            <path d="M24.2426 14.2426L15.7574 22.7279L11.5147 18.4853" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
}

export default AcceptedCircle;
